var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "verificate-wrap"
  }, [_c('div', {
    staticClass: "code-wrap",
    class: {
      mb: _vm.mb
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.code,
      expression: "code"
    }],
    staticClass: "input code",
    class: {
      mb: _vm.mb,
      changeb: _vm.code
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t(_vm.$loginLangPrefix('userSign.inputCode'))
    },
    domProps: {
      "value": _vm.code
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.next();
      },
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.code = $event.target.value;
      }, _vm.codeInput]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "codeimg",
    class: {
      mb: _vm.mb,
      count: _vm.countState
    },
    on: {
      "click": function click($event) {
        return _vm.verification();
      }
    }
  }, [_vm._v(_vm._s(_vm.countState ? "".concat(_vm.count, "s") : _vm.$t(_vm.$loginLangPrefix('userSign.getCode'))))])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };